import { Users } from '@/Interface/user';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '@services/utility.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PlantList } from '@/Interface/plantList';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { PlantByUser } from '@/Interface/plantByUser';
import { UserProfile } from '@/Interface/userProfile';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, finalize } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AccountType } from '@/Interface/userType';
import { DEFAULT_PERMISSIONS } from '@/constants/constants';
import { PermissionsService } from '@services/permissions.service';
import { PlantListModel } from '@/model/plantList';
import { PriorityModel } from '@/model/priority';
import { SourceModel } from '@/model/source';
import { CategoryModel } from '@/model/catlist';
import { SubCategoryModel } from '@/model/subcategory';
import { pakistaniPhoneValidator } from '@/helpers/helpers';
import {
  categoriseFiles,
  formatFileSize,
  MAX_UPLOAD_BYTES,
  timePairValidator,
  totalSize,
  workedHours,
} from '@/helpers/file-size';
import { PlantOwner, Ticket } from '@/Interface/ticketManagementType';
import { FSR, FSRDropdownOption } from '@/Interface/fsrManagementType';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      )
    ])
  ]
})
export class TicketsComponent implements OnInit {
  statusBadgeMap: { [key: string]: string } = {
    assigned: 'badge-blue',
    unassigned: 'badge-warning',
    start: 'badge-cyan',
    'in progress': 'powder-blue',
    'pending material': 'badge-warning',
    'on hold': 'badge-warning',
    resolved: 'badge-success',
    closed: 'badge-gray',
    cancelled: 'badge-danger',
    're_open': 'badge-blue',
    reopen: 'badge-blue'
  };

  selectedUserId: number;
  isSaving: boolean = false;
  userType: any;
  mediumPriority: any;
  isInitializing: any;

  constructor(
    private modalService: NgbModal,
    private _utilityService: UtilityService,
    private _utiltiySevice: UtilityService,
    private formBuilders: FormBuilder,
    private toaster: ToastrService,
    private permService: PermissionsService,
    private router: Router

  ) {
    this.formInitialization()
  }
  @ViewChild('search', { static: false }) search: any;
  userTypelist: AccountType[];
  pageSize: number;
  pageToGo: number = 1;
  searchElement = '';
  serialNumberArray: Array<number> = [];
  next_page: number;
  current_page: number;
  previous_page: number;
  total_pages: number;
  total_items: number;
  private latestQueryParams: any = {};
  sortColumn: string = null;
  sortOrder: 'asc' | 'desc' = null;

  public pageSizeControl = new FormControl(10);
  public pageRecordOptions = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
    { value: '200', label: '200' },
  ];

  public rolesList = []
  public rolesbyTypeList = []
  public filterUserType: number | null = null;
  public filterRole: number | null = null;
  public filterRolesList = [];


  modalRef: NgbModalRef | null = null;
  ticketForm: FormGroup;

  emailAlreadyExists: boolean = false;

  userName: any;
  userEmail: any;
  userProfile: UserProfile;

  user: Users[];
  selectedUser: Users;
  @ViewChild('myTable') table: any;
  selectedCars: number[] = [];
  dataSource: Users;
  rows: any[] = [];
  row: Users[] = [];
  ticketList: Ticket[] = [];
  severity = [];
  ownersInfo = [];
  assignedUsersFilter = [];
  statusFilterList = [];

  plantitem = new PlantListModel;
  priority: PriorityModel[] = [];
  source: SourceModel[] = [];
  categoryList: CategoryModel[] = [];
  getSubcat: SubCategoryModel[] = [];


  USerID: number;

  expandedElement: Users;
  allPlantList: PlantList;
  linkPlant: FormGroup;
  searchSubject: Subject<string> = new Subject();


  PlantByUserlist: PlantByUser;
  message: any;
  loader: boolean = false
  isLoadingTable: boolean = false
  permissions = { ...DEFAULT_PERMISSIONS };

  permissionsReady: boolean = false;

  // Add these properties to the class
  electricianList = [];
  files: File[] = [];
  attachments: any[] = []; // Instead of fileUrls: string[] = [];
  ticketTypeList = [];
  filteredCategoryList = [];
  filteredSubCategoryList = [];
  selectedPlantInfo: any = null;
  isEditMode: boolean = false;
  selectedTicketId: number | null = null;
  MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

  assignForm: FormGroup;
  actionForm: FormGroup;
  actionFiles: File[] = [];
  assignedUserName: string | null = null;

  // --- Corrective FSR (replaces the old Diagnose modal) ---------------
  fsrForm: FormGroup;
  fsrFiles: File[] = [];
  fsrExistingAttachments: any[] = [];
  /** The FSR already filed against the open ticket, if any. */
  linkedFsr: FSR | null = null;
  isSavingFsr = false;
  fsrJobVisitTypes: FSRDropdownOption[] = [];
  fsrComplaintTypes: FSRDropdownOption[] = [];
  fsrCustomerList: PlantOwner[] = [];
  fsrStaffList: PlantOwner[] = [];
  fsrOversizeBreakdown: ReturnType<typeof categoriseFiles> | null = null;
  private fsrOversizeModalRef: NgbModalRef | null = null;

  readonly formatFileSize = formatFileSize;
  ngOnInit(): void {
    this.initComponent()
    // this.getTableData();
    // this.plants();
    const userDetail: any = this._utilityService.decodeUserCode();
    // Customer
    this.userType = userDetail.user_type
    this.formInitialization();
    this.dropDownsInitialization();
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
      this.searchElement = searchTerm;
      this.updateQueryParams({ search: this.searchElement });
    });
  }
  async initComponent() {
    this.loader = true
    await this.getComponentPermissions();

    this.fetchRolesDropdown();
    this.fetchUserTypeDropdown();
    this.linkPlant = this.formBuilders.group({
      plantName: new FormControl(null, Validators.required)
    });
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
      this.searchElement = searchTerm;
      this.updateQueryParams({ search: this.searchElement });
    });
    if (this.permissions.canView) {
      this.formInitialization();
      this.dropDownsInitialization();
      this.getTableData();
      this.loader = false
    }
  }
  async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }
  get hasAnyActionPermission(): boolean {
    return (
      this.permissionsReady &&
      (this.permissions.canView ||
        this.permissions.canEdit ||
        this.permissions.canDelete)
    );
  }
  formInitialization() {
    this.ticketForm = this.formBuilders.group({
      plant: [null, Validators.required],
      title: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(100)]],
      source: [null, Validators.required],
      category: [{ value: null, disabled: true }, Validators.required],
      sub_category: [{ value: null, disabled: true }, Validators.required],
      priority: [null, Validators.required],
      severity: [null, Validators.required],
      poc_username: [null, Validators.required],
      poc_contact: [null, [Validators.required, pakistaniPhoneValidator.bind(this)]],
      description: [null, [Validators.required, Validators.minLength(10), Validators.maxLength(1000)]],
      owner_name: [{ value: '', disabled: true }],
      owner_contact: [{ value: '', disabled: true }],
      region: [{ value: '', disabled: true }],
      city: [{ value: '', disabled: true }]
    });

    this.assignForm = this.formBuilders.group({
      assignee_id: [null, Validators.required]
    });

    // Action form (for hold, pending, close, reopen, cancel)
    this.actionForm = this.formBuilders.group({
      reason: [null, [Validators.required, Validators.maxLength(1000)]]
    });

    // Corrective FSR form — the replacement for the old Diagnose modal.
    this.fsrForm = this.formBuilders.group({
      plant: [null, Validators.required],
      customer: [null],
      // Display-only, mirrored from the selected plant. Disabled so they
      // stay out of .value and are never posted — the backend derives the
      // city from the plant FK.
      region: [{ value: '', disabled: true }],
      city: [{ value: '', disabled: true }],
      job_visit_type: [null, Validators.required],
      // An installation can mix panel types, so this is a repeatable
      // (No. of Panels x Panel Capacity) row rather than one scalar pair.
      panel_groups: this.formBuilders.array([this.buildPanelGroup()]),
      // Derived — disabled so it cannot be posted.
      system_capacity_dc: [{ value: '', disabled: true }],
      assigned_to: [null],
      visit_date: [null],
      time_in: [null],
      time_out: [null],
      total_worked_hours: [{ value: '', disabled: true }],
      description_of_job: [null, Validators.maxLength(2000)],
      complaint_type: [null],
      check_module_cleaning: [false],
      check_loose_connections: [false],
      check_inverter_cleaning: [false],
      check_module_damage: [false],
      repl_broken_panel: [false],
      repl_mc4: [false],
      repl_dc_cable: [false],
      repl_ac_cable: [false],
      repl_others: [false],
      repl_others_detail: [null, Validators.maxLength(500)],
      remarks: [null, Validators.maxLength(2000)]
    }, { validators: timePairValidator });

    // Total Panel Capacity = Σ (No. of Panels x Panel Capacity). The array's
    // valueChanges fires on any row's edit, add, or remove.
    (this.fsrForm.get('panel_groups') as FormArray).valueChanges.subscribe(() =>
      this.recomputeSystemCapacity()
    );
    // Total worked hours from Time In / Time Out, overnight-aware.
    ['time_in', 'time_out'].forEach(field => {
      this.fsrForm.get(field)?.valueChanges.subscribe(() => this.recomputeWorkedHours());
    });
    // "Others" only needs a description when it is actually ticked.
    this.fsrForm.get('repl_others')?.valueChanges.subscribe((checked: boolean) => {
      const control = this.fsrForm.get('repl_others_detail');
      if (checked) {
        control?.addValidators(Validators.required);
      } else {
        control?.removeValidators(Validators.required);
        control?.setValue(null);
      }
      control?.updateValueAndValidity({ emitEvent: false });
    });
  }
  dropDownsInitialization() {
    this.getPlants();
    this.getPriority();
    this.getSeverity();
    this.getAssignedUsers();
    this.getTicketStatus();
    this.getSource();
    this.getCategory();
    this.getSubCategory();
    this.getUser();
  }

  showSuccess(message: string) {
    this.toaster.success(message);
  }

  showError(message: string) {
    this.toaster.error(message);
  }

  sortUsers(column: string): void {
    if (this.sortColumn === column) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortOrder = 'asc';
    }

    let sortValue: string | null = null;
    let columnName: string;

    if (this.sortOrder === 'asc') {
      sortValue = '1';
    } else if (this.sortOrder === 'desc') {
      sortValue = '-1';
    }

    switch (column) {
      case 'username':
        columnName = 'username';
        break;
      default:
        columnName = column;
        break;
    }

    this.updateQueryParams({ sort: sortValue, column: columnName });
  }

  private updateQueryParams(paramsToUpdate: any): void {
    this.latestQueryParams = {
      ...this.latestQueryParams,
      ...paramsToUpdate
    };
    console.log('Updated queryParams:', this.latestQueryParams);

    if (this.latestQueryParams.search === '') {
      this.latestQueryParams.search = null;
    }
    if (this.latestQueryParams.page === 1) {
      this.latestQueryParams.page = null;
    }
    if (this.latestQueryParams.size === 10) {
      this.latestQueryParams.size = null;
    }

    ['sort', 'column', 'assignee', 'priority', 'status'].forEach(key => {
      if (this.latestQueryParams[key] === null) {
        delete this.latestQueryParams[key];
      }
    });

    if (paramsToUpdate.search !== undefined || paramsToUpdate.size !== undefined) {
      this.latestQueryParams = {
        ...this.latestQueryParams,
        size: paramsToUpdate.size ?? this.latestQueryParams.size,
        search: paramsToUpdate.search ?? this.latestQueryParams.search,
        page: paramsToUpdate.page ?? 1
      };
    }
    this.getTableData();
  }

  private getTableData(): void {
    const name = this.latestQueryParams['search'] || this.searchElement;
    console.log('name search', name);
    const page = this.latestQueryParams['page'] ? +this.latestQueryParams['page'] : 1;
    console.log('current Page', page);
    const size = this.latestQueryParams['size'] ? +this.latestQueryParams['size'] : 10;
    const sort = this.latestQueryParams['sort'] || null;
    const column = this.latestQueryParams['column'] || null;
    const assignee = this.latestQueryParams['assignee'] || null;
    const priority = this.latestQueryParams['priority'] || null;
    const status = this.latestQueryParams['status'] ?? null;
    this.fetchTicketList(name, page, size, sort, column, assignee, priority, status);
  }

  fetchTicketList(
    name: string,
    page: number,
    size: number,
    sort: string | null,
    column: string | null,
    assignee: number | null,
    priority: number | null,
    status: number | null
  ): void {
    this.isLoadingTable = true;
    this.row = [];
    this.serialNumberArray = [];

    this._utiltiySevice
      .getTicketList(name, page, size, sort, column, assignee, priority, status)
      .pipe(
        finalize(() => {
          this.isLoadingTable = false;
        })
      )
      .subscribe({
        next: (res: any) => {
          if (res && res.results) {

            this.ticketList = res.results.map((ticket: any, index: number) => ({
              ...ticket,
              srNo:
                (res.pagination.current_page - 1) * size +
                index +
                1
            }));

            this.current_page = res.pagination.current_page;
            this.next_page = res.pagination.next_page;
            this.previous_page = res.pagination.previous_page;
            this.total_pages = res.pagination.total_pages;
            this.total_items = res.pagination.total_records;

            this.enablePagination();

          } else {
            console.error('Unexpected response:', res);
          }
        },

        error: (err) => {
          console.error('Error fetching tickets:', err);

          let errorMessage = 'Failed to load tickets';

          if (err?.error?.message) {
            errorMessage = err.error.message;
          } else if (err?.error?.error) {
            errorMessage = err.error.error;
          } else if (err?.message) {
            errorMessage = err.message;
          }

          this.toaster.error(errorMessage);
          this.ticketList = [];
        }
      });

  }

  public searchData(event: Event): void {
    this.searchElement = (event.target as HTMLInputElement)?.value || '';
    console.log('search Value', this.searchElement);
    this.searchSubject.next(this.searchElement);
  }

  goToPage(page: number): void {
    console.log('move to page', page);
    if (page >= 1 && page <= this.total_pages) {
      this.updateQueryParams({ page: page });
    }
  }

  navigatePage(direction: string): void {
    if (direction === 'prev' && this.current_page > 1) {
      this.goToPage(this.current_page - 1);
    } else if (direction === 'next' && this.next_page !== null) {
      this.goToPage(this.current_page + 1);
    }
  }

  navigateToPage(): void {
    if (this.pageToGo >= 1 && this.pageToGo <= this.total_pages) {
      this.goToPage(this.pageToGo);
    }
  }

  public changePageSize(): void {
    this.pageSize = this.pageSizeControl.value!;
    this.updateQueryParams({ size: this.pageSize })
  }
  // Modify the selectTypelistStatus method
  public selectAssignee(selectedTypeId) {
    this.filterUserType = selectedTypeId;
    this.filterRole = null; // Reset filter role when type changes

    if (selectedTypeId) {
      // Fetch roles for the selected type (for filter only)
      this.fetchFilterRolesBasedOnType(selectedTypeId);
    } else {
      // If no type selected, show all roles
      this.filterRolesList = this.rolesList;
    }

    this.updateQueryParams({ assignee: selectedTypeId, role: null });
  }

  public selectPrioritylistStatus(selectedPriorityId) {
    // this.filterRole = selectedPriorityId;
    this.updateQueryParams({ priority: selectedPriorityId });
  }

  // Add new method for filter roles
  fetchFilterRolesBasedOnType(id: number): void {
    this._utilityService.getUserRoleByType(id).subscribe((res) => {
      if (res) {
        this.filterRolesList = res;
      }
    });
  }
  public selecttStatus(status) {
    this.updateQueryParams({ status: status });
  }

  // onSort(event: any): void {
  //   const sortBy = event.sorts[0];

  //   this.row.sort((a, b) => {
  //     const valueA = a[sortBy.prop];
  //     const valueB = b[sortBy.prop];

  //     if (typeof valueA === 'number' && typeof valueB === 'number') {
  //       return sortBy.dir === 'asc' ? valueA - valueB : valueB - valueA;
  //     } else if (
  //       typeof valueA === 'string' &&
  //       typeof valueB === 'string'
  //     ) {
  //       return sortBy.dir === 'asc'
  //         ? valueA.localeCompare(valueB)
  //         : valueB.localeCompare(valueA);
  //     } else {
  //       return String(valueA).localeCompare(String(valueB));
  //     }
  //   });
  // }
  onSort(event: any): void {
    const sortBy = event.sorts[0];
    const sortValue = sortBy.dir === 'asc' ? '1' : '-1';
    this.updateQueryParams({ sort: sortValue, column: sortBy.prop });
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.close('Closed');
    }
    this.selectedUser = null
    this.selectedUserId = null
  }

  resetForm() {
    this.ticketForm.reset();
    this.assignForm.reset();
    this.actionForm.reset();
    this.fsrForm.reset();

    // **Clear ALL file arrays**
    this.files = [];
    this.actionFiles = [];
    this.attachments = [];

    this.selectedPlantInfo = null;
    this.filteredCategoryList = [];
    this.filteredSubCategoryList = [];
    this.isEditMode = false;
    this.selectedTicketId = null;
    this.USerID = null;
    this.assignedUserName = null;
    this.rolesbyTypeList = [];
    this.electricianList = [];
    this.ticketForm.get('category')?.disable();
    this.ticketForm.get('sub_category')?.disable();
    if (this.userType === 'Customer') {
      this.ticketForm.patchValue({ priority: this.mediumPriority.id });
    }
  }
  addNewTicket(content: any) {
    this.isEditMode = false;
    this.files = [];
    this.attachments = [];
    this.resetForm();
    this.modalRef = this.modalService.open(content, { centered: true, size: 'lg' });
    if (this.modalRef) {
      this.modalRef.hidden.subscribe((result) => {
        this.resetForm();
      });
    }
  }
  save() {
    if (this.ticketForm.invalid) {
      Object.keys(this.ticketForm.controls).forEach(key => {
        this.ticketForm.get(key)?.markAsTouched();
      });
      this.toaster.error('Please fill all required fields correctly.');
      return;
    }
    const raw = this.ticketForm.getRawValue();

    const formData = new FormData();

    // Append form values
    formData.append('plant', raw.plant);
    formData.append('title', raw.title);
    formData.append('source', raw.source);
    formData.append('category', raw.category);
    formData.append('sub_category', raw.sub_category);
    formData.append('priority', raw.priority);
    formData.append('severity', raw.severity);
    formData.append('poc_contact', raw.poc_contact);
    formData.append('poc_username', raw.poc_username);
    formData.append('description', raw.description);
    // formData.append('plant', this.ticketForm.get('plant')?.value);
    // formData.append('title', this.ticketForm.get('title')?.value);
    // formData.append('source', this.ticketForm.get('source')?.value);
    // formData.append('category', this.ticketForm.get('category')?.value);
    // formData.append('sub_category', this.ticketForm.get('sub_category')?.value);
    // formData.append('priority', this.ticketForm.get('priority')?.value);
    // formData.append('severity', this.ticketForm.get('severity')?.value);
    // formData.append('poc_contact', this.ticketForm.get('poc_contact')?.value);
    // formData.append('poc_username', this.ticketForm.get('poc_username')?.value);
    // formData.append('description', this.ticketForm.get('description')?.value);

    // Append files
    this.files.forEach((file, index) => {
      formData.append('attachments', file, file.name);
    });

    // If edit mode, keep existing file URLs
    // if (this.isEditMode && this.attachments.length > 0) {
    //   const existingAttachmentIds = this.attachments.map(att => att.id);
    //   formData.append('existing_attachments', JSON.stringify(existingAttachmentIds));
    // }


    // console.log('Form Data to be submitted:', formData);
    this.isSaving = true;
    const request$ = this.isEditMode
      ? this._utilityService.updateTicket(this.selectedTicketId, formData)
      : this._utilityService.createTicket(formData);

    request$.pipe(
      finalize(() => {
        this.isSaving = false;
      })
    ).subscribe({
      next: (res) => {
        this.toaster.success(
          this.isEditMode ? 'Ticket updated successfully' : 'Ticket created successfully'
        );
        this.closeModal();
        this.getTableData();
      },
      error: (err) => {
        // const errorMessage = err?.error?.message || err?.message || 'Operation failed';
        // this.toaster.error(errorMessage);
        this.handleApiFieldErrors(err,this.toaster)
      }
    });
  }

  open(content: any, row: any) {
    this.isInitializing = true;
    this.isEditMode = true;
    this.selectedTicketId = row.id;
    this.selectedUser = row;

    this.files = [];
    this.attachments = [];

    // Populate form with existing data
    this.ticketForm.patchValue({
      plant: row.plant?.id,
      title: row.title,
      source: row.source?.id,
      category: row.category?.id,
      sub_category: row.sub_category?.id,
      priority: row.priority?.id,
      severity: row.severity,
      poc_username: row.poc_username,
      poc_contact: row.poc_contact,
      description: row.description
    });

    // Load plant info if plant exists
    if (row.plant?.id) {
      this.onPlantChange(row.plant);
    }

    // Load cascading dropdowns
    if (row.source?.id) {
      this.onTicketTypeChange(row.source);
    }
    if (row.category?.id) {
      this.onCategoryChange(row.category);
    }

    // Handle file URLs from response
    if (row.attachments && row.attachments.length > 0) {
      this.attachments = row.attachments;
    }
    this.isInitializing = false;
    this.modalRef = this.modalService.open(content, { centered: true, size: 'lg', scrollable: true });
  }
  onPlantChange(plant: any) {
    if (!plant || (!plant.id && !plant.station_id)) {
      this.selectedPlantInfo = null;
      this.ticketForm.patchValue({
        owner_name: '',
        owner_contact: '',
        region: '',
        city: ''
      });
      return;
    }
    const identifier = plant.id || plant.station_id;
    this._utilityService.fetchStationInfo(identifier, null).subscribe((res: any) => {
      if (res?.data?.length) {

        const station = res.data[0];
        this.selectedPlantInfo = station;

        const ownerNames =
          station.owners?.map((o: any) => o.full_name).join(', ') || '';

        const ownerContacts =
          station.owners?.map((o: any) => o.contact_number).join(', ') || '';

        this.ticketForm.patchValue({
          owner_name: ownerNames,
          owner_contact: ownerContacts,
          region: station.region || 'null',
          city: station.city || 'null'
        });
      }
    });
  }

  onTicketTypeChange(ticketType: any) {
    const ticketTypeId = ticketType?.id;

    // Always reset values
    this.filteredCategoryList = [];
    this.filteredSubCategoryList = [];
    if (!this.isInitializing) {
      this.ticketForm.patchValue({
        category: null,
        sub_category: null
      });
    }

    // Only disable if no type selected
    if (!ticketTypeId) {
      this.ticketForm.get('category')?.disable();
      this.ticketForm.get('sub_category')?.disable();
      return;
    }

    // If valid type, keep category enabled (no flicker)
    this.ticketForm.get('category')?.enable();
    this.ticketForm.get('sub_category')?.disable();

    this._utilityService.getCategoryBySourceId(ticketTypeId).subscribe((res) => {
      this.filteredCategoryList = res || [];
    });
  }


  onCategoryChange(category: any) {
    const categoryId = category?.id;

    this.filteredSubCategoryList = [];
    if (!this.isInitializing) {
      this.ticketForm.patchValue({
        sub_category: null
      });
    }

    if (!categoryId) {
      this.ticketForm.get('sub_category')?.disable();
      return;
    }

    this.ticketForm.get('sub_category')?.enable();

    this._utilityService.getSubCategoryByCatId(categoryId).subscribe((res) => {
      this.filteredSubCategoryList = res || [];
    });
  }
  onFileChange(event: any) {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    let totalSize = this.files.reduce((sum, f) => sum + f.size, 0);
    const validFiles: File[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileType = file.type;

      if (!fileType.startsWith('image/') && fileType !== 'application/pdf') {
        this.toaster.warning(`Invalid file type: ${file.name}. Only images and PDFs allowed.`);
        continue;
      }

      totalSize += file.size;

      if (totalSize > this.MAX_FILE_SIZE) {
        this.toaster.warning('Total file size cannot exceed 10MB.');
        return;
      }

      validFiles.push(file);
    }

    this.files = [...this.files, ...validFiles];
  }

  // onFileChange(event: any) {
  //   const files = event.target.files;
  //   if (!files || files.length === 0) return;

  //   let totalSize = 0;
  //   const validFiles: File[] = [];

  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];
  //     const fileType = file.type;

  //     // Validate file type (images and PDFs only)
  //     if (!fileType.startsWith('image/') && fileType !== 'application/pdf') {
  //       this.toaster.error(`Invalid file type: ${file.name}. Only images and PDFs are allowed.`);
  //       continue;
  //     }

  //     totalSize += file.size;
  //     validFiles.push(file);
  //   }

  //   // Check total size
  //   if (totalSize > this.MAX_FILE_SIZE) {
  //     this.toaster.error('Total file size exceeds 10MB limit.');
  //     return;
  //   }

  //   this.files = [...this.files, ...validFiles];
  // }

  removeFile(index: number) {
    this.files.splice(index, 1);
  }

  removeAttachment(index: number) { // Renamed from removeFileUrl
    this.attachments.splice(index, 1);
  }

  showLink(link: any, row: Users) {
    this.modalService.open(link, { windowClass: 'complainModelClass' });
    var userInlist = row.user_id;
    this.table.rowDetail.toggleExpandRow(row);
    this._utilityService.showLinkPlant(userInlist).subscribe((res) => {
      if (res) {
        this.PlantByUserlist = res.data;
      }
    });
  }

  FiltergetUser(filter: string, filterType: string) {
    this._utilityService.receiveUserFilter(filterType + "=" + filter).subscribe((res) => {
      if (res) {
        var response = res;
        this.setExtraData(res);
      }
    });
  }

  setExtraData(response: any) {
    var totalCount = response.total_users;
    // console.log('setExtraData', totalCount)
    var totalPages = response.total_pages;
    var currentPage = response.current_page;
    var rowIndex = 0;
    this.row = [];
    for (var i = 1; i <= totalPages; i++) {
      for (var k = 0; k < 10; k++, rowIndex++) {
        if (rowIndex < response.total_users) {
          this.row.push(response.data[k]);
        }
        else {
          break;
        }
      }
    }
  }

  usersPageChange(event: any) {
    var newPage = parseInt(event.offset) + 1;
    console.log('usersPageChange', newPage)
    this.FiltergetUser(event.offset + 1, 'page');
  }

  Search() {
    if (this.userName == '') {
      this.ngOnInit();
    } else {
      console.log('inside search function')
      this.row = this.row.filter((res) => {
        return res.username
          ?.toLocaleLowerCase()
          .match(this.userName?.toLocaleLowerCase());
      });
    }
  }

  searchByEmail() {
    if (this.userEmail == '') {
      this.ngOnInit();
    } else {
      this.row = this.row.filter((res) => {
        return res.email
          ?.toLocaleLowerCase()
          .match(this.userEmail?.toLocaleLowerCase());
      });
    }
  }


  plants() {
    this._utilityService.PlantsdetailsAll().subscribe((res) => {
      if (res) {
        this.allPlantList = res.data;
      }
    });
  }
  getPlants() {
    this._utilityService.fetchStationInfo(null, null).subscribe((res) => {
      if (res) {
        this.plantitem = res.data || [];
      }
    });
  }
  // getPriority() {
  //   this._utilityService.receivePreority().subscribe((res) => {
  //     if (res) {
  //       this.priority = res;
  //     }
  //   });
  // }
  getPriority() {
    this._utilityService.receivePreority().subscribe((res) => {
      if (res) {
        this.priority = res;

        // Auto-select "Medium" priority for customer users
        if (this.userType === 'Customer') {
          this.mediumPriority = res.find(
            (p: any) => p.name?.toLowerCase() === 'medium' || p.name?.toLowerCase() === 'normal'
          );
          if (this.mediumPriority) {
            this.ticketForm.patchValue({ priority: this.mediumPriority.id });
            this.ticketForm.get('priority')?.disable();
          }

        }
      }
    });
  }
  getSeverity() {
    this._utilityService.fetchSeverity().subscribe((res) => {
      if (res) {
        this.severity = res;
      }
    });
  }
  getPlantInfo(plantId: number | null) {
    this._utilityService.fetchSeverity().subscribe((res) => {
      if (res) {
        this.severity = res;
      }
    });
  }
  getAssignedUsers() {
    this._utilityService.assignedTicketUsers().subscribe((res) => {
      if (res) {
        this.assignedUsersFilter = res;
      }
    });
  }
  getTicketStatus() {
    this._utilityService.getTicketStatusList().subscribe((res) => {
      if (res) {
        this.statusFilterList = res;
      }
    });
  }
  getSource() {
    this._utilityService.receiveSource().subscribe((res) => {
      if (res) {
        this.source = res;
      }
    });
  }

  getCategory() {
    this._utilityService.receiveCategory().subscribe((res) => {
      if (res) {
        this.categoryList = res;
      }
    });
  }

  getSubCategory() {
    this._utilityService.sendSubCat().subscribe((res) => {
      if (res) {
        this.getSubcat = res;
      }
    });
  }

  getUser() {
    this._utilityService.receiveNocUser().subscribe((res) => {
      if (res) {
        this.user = res;
      }
    });
  }
  getElectrican(plant: any) {
    const stationId = plant?.id || null;
    if (stationId) {
      this._utilityService.fetchStationInfo(stationId, 1).subscribe((res) => {
        if (res) {
          this.electricianList = res.data[0].owners || [];
        }
      });
    }
    else {
      this.electricianList = null
    }
  }
  getStationInfo(plant: any) {
    const stationId = plant?.id || null;
    if (stationId) {
      this._utilityService.fetchStationInfo(stationId).subscribe((res) => {
        if (res) {
          this.ownersInfo = res;
        }
      });
    }
    else {
      this.ownersInfo = null
    }
  }

  disableUser(userId) {
    this.disableUserPopup(userId);
  }

  openDelModal(id: number, content: any) {
    this.modalService.open(content, { centered: true }).result.then(
      (result) => {
        if (result === 'confirm') {
          this._utiltiySevice.disableUserApi(id).subscribe((res) => {
            if (res) {
              console.log("Success");
              this.row.filter(item => item.user_id === id)[0].is_active = false;
            }
          })
          this.toaster.success('User has been inactive')
          this.getTableData();
        }
      },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }

  disableUserPopup(userId) {
    Swal.fire({
      title: 'Are you sure you want to disable this User?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FB8C04',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, disable it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this._utiltiySevice.disableUserApi(userId).subscribe((res) => {
          if (res) {
            console.log("Success");
            this.row.filter(item => item.user_id === userId)[0].is_active = false;
          }
        })
        Swal.fire(
          'Disabled!',
          'user has been disabled.',
          'success'
        )
        this.getTableData();
      }
    })
  }

  enablePagination() {
    const linkElement = document.getElementById('prevPage');

    if (this.previous_page === null) {
      linkElement.setAttribute('disabled', 'true');
      linkElement.style.pointerEvents = 'none';
      linkElement.style.color = 'gray';
      linkElement.addEventListener('click', (event) => {
        event.preventDefault();
      });
    } else {
      linkElement.removeAttribute('disabled');
      linkElement.style.pointerEvents = 'auto';
      linkElement.style.color = '';
      linkElement.removeEventListener('click', (event) => {
        event.preventDefault();
      });
    }
  }

  fetchUserTypeDropdown() {
    this._utilityService.getUserTypesHierarchyDropdown().subscribe((res) => {
      if (res) {
        this.userTypelist = res;
      }
    });
  }

  fetchRolesDropdown(): void {
    this._utilityService.getUserRole().subscribe((res) => {
      if (res) {
        this.rolesList = res;
        this.filterRolesList = res;
      }
    });
  }

  fetchRolesBasedOnTypeDropdown(id: number): void {
    this._utilityService.getUserRoleByType(id).subscribe((res) => {
      if (res) {
        this.rolesbyTypeList = res;
        console.log('Roles for type', id, ':', this.rolesbyTypeList);
      }
    });
  }
  normalizeStatus(status: string): string {
    return status.toLowerCase().trim().replace(/\s+/g, ' ');
  }

  getStatusBadgeClass(status: string): string {
    if (!status) return '';
    return this.statusBadgeMap[this.normalizeStatus(status)] || 'badge-blue';
  }

  // Add these helper methods to your component class

  isImageFile(file: File | any): boolean {

    // Case 1: Real File object
    if (file instanceof File) {
      return (
        file.type.startsWith('image/') ||
        file.type === 'image/svg+xml'
      );
    }

    // Case 2: Attachment object with file_url
    if (file?.file_url) {
      const url = file.file_url.toLowerCase();

      return (
        url.endsWith('.jpg') ||
        url.endsWith('.jpeg') ||
        url.endsWith('.png') ||
        url.endsWith('.gif') ||
        url.endsWith('.webp') ||
        url.endsWith('.svg')
      );
    }

    return false;
  }


  isPdfFile(file: File | any): boolean {
    if (file instanceof File) {
      return file.type === 'application/pdf';
    }
    // For attachment objects with file_url
    if (file.file_url) {
      return file.file_url.toLowerCase().endsWith('.pdf');
    }
    return false;
  }
  // actions code

  // Assign Ticket
  assignTicket() {
    if (this.assignForm.invalid) {
      this.assignForm.markAllAsTouched();
      this.toaster.error('Please select a user');
      return;
    }

    const payload = {
      assignee_id: this.assignForm.get('assignee_id')?.value
    };

    console.log('Assign Ticket Payload:', payload);
    this.loader = true;

    this._utilityService.assignTicket(this.selectedTicketId, payload)
      .pipe(finalize(() => this.loader = false))
      .subscribe({
        next: (res) => {
          this.toaster.success('Ticket assigned successfully');
          this.closeModal();
          this.getTableData();
        },
        error: (err) => {
          this.handleApiFieldErrors(err, this.toaster);
        }
      });
  }

  // Start Ticket
  startTicket() {
    console.log('Start Ticket - ID:', this.selectedTicketId);
    this.loader = true;

    this._utilityService.startTicket(this.selectedTicketId)
      .pipe(finalize(() => this.loader = false))
      .subscribe({
        next: (res) => {
          this.toaster.success('Ticket started successfully');
          this.closeModal();
          this.getTableData();
        },
        error: (err) => {
          this.handleApiFieldErrors(err, this.toaster);
        }
      });
  }

  // On Hold Ticket
  holdTicket() {
    if (this.actionForm.invalid) {
      this.actionForm.markAllAsTouched();
      this.toaster.error('Please provide a reason (minimum 10 characters)');
      return;
    }

    const payload = {
      reason: this.actionForm.get('reason')?.value
    };

    console.log('Hold Ticket Payload:', payload);
    this.loader = true;

    this._utilityService.holdTicket(this.selectedTicketId, payload)
      .pipe(finalize(() => this.loader = false))
      .subscribe({
        next: (res) => {
          this.toaster.success('Ticket put on hold successfully');
          this.closeModal();
          this.getTableData();
        },
        error: (err) => {
          this.handleApiFieldErrors(err, this.toaster);
        }
      });
  }

  // Pending Material
  pendingTicket() {
    if (this.actionForm.invalid) {
      this.actionForm.markAllAsTouched();
      this.toaster.error('Please provide a reason (minimum 10 characters)');
      return;
    }

    const payload = {
      reason: this.actionForm.get('reason')?.value
    };

    console.log('Pending Material Payload:', payload);
    this.loader = true;

    this._utilityService.pendingTicket(this.selectedTicketId, payload)
      .pipe(finalize(() => this.loader = false))
      .subscribe({
        next: (res) => {
          this.toaster.success('Ticket marked as pending material');
          this.closeModal();
          this.getTableData();
        },
        error: (err) => {
          this.handleApiFieldErrors(err, this.toaster);
        }
      });
  }

  // ------------------------------------------------------------------
  // Corrective FSR — the Diagnose action's replacement.
  //
  // One FSR per ticket: the first save creates it, later saves update it. It
  // stays out of the FSR listing until the ticket reaches a terminal status.
  // ------------------------------------------------------------------

  private buildPanelGroup(overrides: { number_of_panels?: number | null; panel_capacity?: number | null } = {}): FormGroup {
    return this.formBuilders.group({
      number_of_panels: [overrides.number_of_panels ?? null, [Validators.required, Validators.min(1)]],
      panel_capacity: [overrides.panel_capacity ?? null, [Validators.required, Validators.min(0.001)]],
    });
  }

  addPanelGroup(): void {
    (this.fsrForm.get('panel_groups') as FormArray).push(this.buildPanelGroup());
  }

  removePanelGroup(index: number): void {
    const array = this.fsrForm.get('panel_groups') as FormArray;
    if (array.length > 1) {
      array.removeAt(index);
    }
  }

  private recomputeSystemCapacity(): void {
    const groups = (this.fsrForm.get('panel_groups') as FormArray).value as Array<{
      number_of_panels: unknown;
      panel_capacity: unknown;
    }>;
    let total = 0;
    let hasValidRow = false;
    for (const group of groups) {
      // Decimals come back from the API as strings, so coerce before multiplying.
      const panels = Number(group.number_of_panels);
      const capacity = Number(group.panel_capacity);
      if (Number.isFinite(panels) && Number.isFinite(capacity) && panels > 0 && capacity > 0) {
        total += panels * capacity;
        hasValidRow = true;
      }
    }
    const value = hasValidRow ? total.toFixed(3) : '';
    this.fsrForm.get('system_capacity_dc')?.setValue(value, { emitEvent: false });
  }

  private recomputeWorkedHours(): void {
    const value = workedHours(
      this.fsrForm.get('time_in')?.value,
      this.fsrForm.get('time_out')?.value
    );
    this.fsrForm.get('total_worked_hours')?.setValue(value, { emitEvent: false });
  }

  resetFsrForm(): void {
    this.fsrForm.reset({
      check_module_cleaning: false,
      check_loose_connections: false,
      check_inverter_cleaning: false,
      check_module_damage: false,
      repl_broken_panel: false,
      repl_mc4: false,
      repl_dc_cable: false,
      repl_ac_cable: false,
      repl_others: false
    });
    // .reset() clears each row's value but leaves the array's length alone —
    // collapse back to exactly one empty row.
    const panelGroupsArray = this.fsrForm.get('panel_groups') as FormArray;
    panelGroupsArray.clear();
    panelGroupsArray.push(this.buildPanelGroup());
    this.fsrFiles = [];
    this.fsrExistingAttachments = [];
    this.fsrCustomerList = [];
    this.fsrStaffList = [];
    this.fsrOversizeBreakdown = null;
    this.linkedFsr = null;
  }

  /**
   * Open the FSR modal for a ticket, prefilling any FSR already filed against
   * it. Opened with size/scrollable options of its own — openAction()'s are
   * sized for small confirmation dialogs and would clip this form.
   */
  openFsrModal(content: any, row: any): void {
    this.selectedTicketId = row.id;
    this.selectedUser = row;
    this.resetFsrForm();

    // The plant is inherited from the ticket and cannot be changed.
    this.fsrForm.patchValue({ plant: row.plant?.id ?? null }, { emitEvent: false });

    if (!this.fsrJobVisitTypes.length) {
      this._utilityService.getFsrJobVisitTypes().subscribe((res: any) => {
        this.fsrJobVisitTypes = res || [];
      });
    }
    if (!this.fsrComplaintTypes.length) {
      this._utilityService.getFsrComplaintTypes().subscribe((res: any) => {
        this.fsrComplaintTypes = res || [];
      });
    }

    const ticketId = row.id;
    const plantId = row.plant?.id ?? null;

    if (plantId) {
      // electrician=0 -> Customer owners, 1 -> Electrician owners. Both args are
      // always passed: the service guards on `!== null`, so omitting one sends
      // `electrician=undefined` and the backend's int() cast 500s.
      this._utilityService.fetchStationInfo(plantId, 0).subscribe((res: any) => {
        // Guard: a different row may have been clicked while this was in flight.
        if (this.selectedTicketId !== ticketId) { return; }
        this.fsrCustomerList = res?.data?.[0]?.owners || [];
        // Same response carries the plant's city and region names.
        this.fsrForm.patchValue({
          region: res?.data?.[0]?.region || '',
          city: res?.data?.[0]?.city || ''
        }, { emitEvent: false });
        if (this.fsrCustomerList.length === 1 && !this.fsrForm.get('customer')?.value) {
          this.fsrForm.patchValue({ customer: this.fsrCustomerList[0].id }, { emitEvent: false });
        }
      });
      this._utilityService.fetchStationInfo(plantId, 1).subscribe((res: any) => {
        if (this.selectedTicketId !== ticketId) { return; }
        this.fsrStaffList = res?.data?.[0]?.owners || [];
      });
    }

    // 404 simply means no FSR has been filed yet — not an error worth a toast.
    this._utilityService.getTicketFsr(ticketId).subscribe({
      next: (fsr: FSR) => {
        if (this.selectedTicketId !== ticketId) { return; }
        this.patchFsrForm(fsr);
      },
      error: () => { /* first FSR for this ticket */ }
    });

    this.modalRef = this.modalService.open(content, {
      size: 'fullscreen',
      keyboard: false
    });
    this.modalRef.hidden.subscribe(() => {
      this.modalRef = null;
    });
  }

  private patchFsrForm(fsr: FSR): void {
    this.linkedFsr = fsr;
    this.fsrExistingAttachments = fsr.attachments || [];

    const panelGroupsArray = this.fsrForm.get('panel_groups') as FormArray;
    panelGroupsArray.clear();
    const rowGroups = fsr.panel_groups?.length ? fsr.panel_groups : [{ number_of_panels: null, panel_capacity: null }];
    rowGroups.forEach((group) => {
      panelGroupsArray.push(this.buildPanelGroup({
        number_of_panels: group.number_of_panels,
        panel_capacity: group.panel_capacity !== null ? Number(group.panel_capacity) : null,
      }));
    });

    this.fsrForm.patchValue({
      plant: fsr.plant?.id ?? null,
      customer: fsr.customer,
      job_visit_type: fsr.job_visit_type,
      assigned_to: fsr.assigned_to?.id ?? null,
      visit_date: fsr.visit_date,
      time_in: fsr.time_in,
      time_out: fsr.time_out,
      description_of_job: fsr.description_of_job,
      complaint_type: fsr.complaint_type,
      check_module_cleaning: fsr.check_module_cleaning,
      check_loose_connections: fsr.check_loose_connections,
      check_inverter_cleaning: fsr.check_inverter_cleaning,
      check_module_damage: fsr.check_module_damage,
      repl_broken_panel: fsr.repl_broken_panel,
      repl_mc4: fsr.repl_mc4,
      repl_dc_cable: fsr.repl_dc_cable,
      repl_ac_cable: fsr.repl_ac_cable,
      repl_others: fsr.repl_others,
      repl_others_detail: fsr.repl_others_detail,
      remarks: fsr.remarks
    });
  }

  /** Fed by both the file picker and the dropzone in <app-fsr-form>. */
  addFsrFiles(selected: FileList): void {
    if (!selected?.length) { return; }
    for (let i = 0; i < selected.length; i++) {
      this.fsrFiles.push(selected[i]);
    }
  }

  removeFsrFile(index: number): void {
    this.fsrFiles.splice(index, 1);
  }

  saveTicketFsr(warningModal: any): void {
    if (this.fsrForm.invalid) {
      this.fsrForm.markAllAsTouched();
      this.toaster.error('Please fill all required fields correctly.');
      return;
    }
    if (this.fsrCustomerList.length > 1 && !this.fsrForm.get('customer')?.value) {
      this.toaster.error('Please select a customer.');
      return;
    }

    // Warn about an oversized batch before sending anything over the wire.
    if (totalSize(this.fsrFiles) > MAX_UPLOAD_BYTES) {
      this.fsrOversizeBreakdown = categoriseFiles(this.fsrFiles);
      this.fsrOversizeModalRef = this.modalService.open(warningModal, {
        centered: true,
        backdrop: 'static'
      });
      return;
    }

    this.submitTicketFsr(false);
  }

  confirmCompressAndUploadFsr(): void {
    this.fsrOversizeModalRef?.close('compress');
    this.fsrOversizeModalRef = null;
    this.submitTicketFsr(true);
  }

  cancelFsrOversizeUpload(): void {
    this.fsrOversizeModalRef?.dismiss('cancel');
    this.fsrOversizeModalRef = null;
    this.fsrOversizeBreakdown = null;
  }

  private submitTicketFsr(compress: boolean): void {
    const raw = this.fsrForm.getRawValue();
    const formData = new FormData();

    // The two derived display fields are never posted.
    const skip = new Set(['system_capacity_dc', 'total_worked_hours', 'region', 'city']);
    Object.keys(raw).forEach(key => {
      if (skip.has(key)) { return; }
      const value = raw[key];
      if (value === null || value === undefined || value === '') { return; }
      // Multipart can't carry a native nested array — the backend parses
      // this as a JSON-encoded string (see parse_panel_groups in fsr_management.py).
      if (key === 'panel_groups') {
        formData.append(key, JSON.stringify(value));
        return;
      }
      formData.append(key, value as any);
    });

    this.fsrFiles.forEach(file => formData.append('attachments', file, file.name));
    if (compress) {
      formData.append('compress', 'true');
    }

    this.isSavingFsr = true;
    this._utilityService.saveTicketFsr(this.selectedTicketId, formData)
      .pipe(finalize(() => this.isSavingFsr = false))
      .subscribe({
        next: (res: any) => {
          this.toaster.success(this.linkedFsr ? 'FSR updated successfully' : 'FSR created successfully');
          // The FSR saved even when its attachments did not — say so rather than
          // letting the user believe the files went up.
          if (res?.attachment_warning) {
            this.toaster.warning(res.attachment_warning, 'Attachments not saved', {
              timeOut: 12000,
              closeButton: true
            });
          }
          this.closeModal();
          this.getTableData();
        },
        error: (err) => {
          this.handleApiFieldErrors(err, this.toaster);
        }
      });
  }

  // Resolve Ticket
  resolveTicket() {
    console.log('Resolve Ticket - ID:', this.selectedTicketId);
    this.loader = true;

    this._utilityService.resolveTicket(this.selectedTicketId)
      .pipe(finalize(() => this.loader = false))
      .subscribe({
        next: (res) => {
          this.toaster.success('Ticket resolved successfully');
          this.closeModal();
          this.getTableData();
        },
        error: (err) => {
          this.handleApiFieldErrors(err, this.toaster);
        }
      });
  }

  // Close Ticket
  closeTicket() {
    if (this.actionForm.invalid) {
      this.actionForm.markAllAsTouched();
      this.toaster.error('Please provide a reason (minimum 10 characters)');
      return;
    }

    const payload = {
      reason: this.actionForm.get('reason')?.value
    };

    console.log('Close Ticket - ID:', this.selectedTicketId, payload);
    this.loader = true;

    this._utilityService.closeTicketApi(this.selectedTicketId, payload)
      .pipe(finalize(() => this.loader = false))
      .subscribe({
        next: (res) => {
          this.toaster.success('Ticket closed successfully');
          this.closeModal();
          this.getTableData();
        },
        error: (err) => {
          this.handleApiFieldErrors(err, this.toaster);
        }
      });
  }

  // Reopen Ticket
  reopenTicket() {
    if (this.actionForm.invalid) {
      this.actionForm.markAllAsTouched();
      this.toaster.error('Please provide a reason (minimum 10 characters)');
      return;
    }

    const payload = {
      reason: this.actionForm.get('reason')?.value
    };

    // console.log('Reopen Ticket Payload:', payload);
    this.loader = true;

    this._utilityService.reopenTicket(this.selectedTicketId, payload)
      .pipe(finalize(() => this.loader = false))
      .subscribe({
        next: (res) => {
          this.toaster.success('Ticket reopened successfully');
          this.closeModal();
          this.getTableData();
        },
        error: (err) => {
          this.handleApiFieldErrors(err, this.toaster);
        }
      });
  }

  // Cancel Ticket
  cancelTicket() {
    if (this.actionForm.invalid) {
      this.actionForm.markAllAsTouched();
      this.toaster.error('Please provide a reason (minimum 10 characters)');
      return;
    }

    const payload = {
      reason: this.actionForm.get('reason')?.value
    };

    console.log('Cancel Ticket Payload:', payload);
    this.loader = true;

    this._utilityService.cancelTicket(this.selectedTicketId, payload)
      .pipe(finalize(() => this.loader = false))
      .subscribe({
        next: (res) => {
          this.toaster.success('Ticket cancelled successfully');
          this.closeModal();
          this.getTableData();
        },
        error: (err) => {
          this.handleApiFieldErrors(err, this.toaster);
        }
      });
  }

  // File handling for the reason-based action modals
  // onActionFileChange(event: any) {
  //   const files = event.target.files;
  //   if (!files || files.length === 0) return;

  //   let totalSize = 0;
  //   const validFiles: File[] = [];

  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];
  //     const fileType = file.type;

  //     if (!fileType.startsWith('image/') && fileType !== 'application/pdf') {
  //       this.toaster.error(`Invalid file type: ${file.name}. Only images and PDFs allowed.`);
  //       continue;
  //     }

  //     totalSize += file.size;
  //     validFiles.push(file);
  //   }

  //   if (totalSize > this.MAX_FILE_SIZE) {
  //     this.toaster.error('Total file size exceeds 10MB limit.');
  //     return;
  //   }

  //   this.actionFiles = [...this.actionFiles, ...validFiles];
  // }
  onActionFileChange(event: any) {
  const files = event.target.files;
  if (!files || files.length === 0) return;

  let totalSize = this.actionFiles.reduce((sum, f) => sum + f.size, 0);
  const validFiles: File[] = [];

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const fileType = file.type;

    if (!fileType.startsWith('image/') && fileType !== 'application/pdf') {
      this.toaster.error(`Invalid file type: ${file.name}. Only images and PDFs allowed.`);
      continue;
    }

    totalSize += file.size;

    if (totalSize > this.MAX_FILE_SIZE) {
      this.toaster.error('Total file size cannot exceed 10MB.');
      return;
    }

    validFiles.push(file);
  }

  this.actionFiles = [...this.actionFiles, ...validFiles];
}


  removeActionFile(index: number) {
    this.actionFiles.splice(index, 1);
  }

  // Update openAction to reset forms
  openAction(content: any, row: any) {
    this.selectedTicketId = row.id;
    this.selectedUser = row;
    this.assignedUserName = row.assignee?.first_name || null;

    // Reset forms
    this.actionForm.reset();
    this.assignForm.reset();
    this.fsrForm.reset();
    this.actionFiles = [];
    this.getElectrican(row.plant);

    setTimeout(() => {
      this.modalRef = this.modalService.open(content, {
        centered: true,
        backdrop: 'static', // Prevents closing on outside click
        keyboard: false // Prevents closing on ESC key
      });
    }, 0);
  }
  canShowAction(row: any, action: string): boolean {
    return (
      row?.user_permissions?.[action] === true &&
      row?.ticket_actions?.includes(action)
    );
  }
  handleApiFieldErrors(error: HttpErrorResponse, toastr: ToastrService): void {

    // Case 1: status is an array
    if (error.error?.status && Array.isArray(error.error.status)) {
      error.error.status.forEach((msg: string) => {
        toastr.error(msg);
      });
      return;
    }
    // Case 2: { error: "string" }
    if (error.error?.error && typeof error.error.error === 'string') {
      toastr.error(error.error.error);
      return;
    }

    // Case 2: single message
    if (error.error?.message) {
      toastr.error(error.error.message);
      return;
    }

    // Case 3: field validation errors
    if (error.error?.errors) {
      const errors = error.error.errors;
      Object.keys(errors).forEach(key => {
        const message = Array.isArray(errors[key]) ? errors[key][0] : errors[key];
        toastr.error(message);
      });
      return;
    }

    // Fallback
    toastr.error('Sorry, something went wrong. Please try again.');
  }

  viewTicket(id: number): void {
    this.router.navigate(['/help-desk/tickets', id]);
  }
}